import React from 'react';
import '../css/conoceACarmen.css';
import fotoCarmen from '../images/carmen.jpeg'; // Ajusta la ruta a tu imagen

const ConoceACarmen = () => {
  return (
    <div className="carmen-container">
      <h1 className="carmen-title">Conoce a Carmen</h1>
          <div className="header-divider"></div>
      
      <article className="carmen-article">
        <img 
          src={fotoCarmen} 
          alt="Carmen" 
          className="carmen-image" 
        />

        
        <div className="carmen-text">
          <p>
            Carmen nació un 30 de diciembre de 2007, como nacen las cosas buenas: 
            sin hacer ruido, pero destinadas a dejar huella. Desde el primer momento 
            fue luz, de esa que no se ve pero se siente, de la que transforma a quienes la rodean.
          </p>

          <p>
            Fue una hija que enseñó más de lo que nunca necesitó aprender, una hermana 
            que convirtió cada instante en complicidad y una niña capaz de regalar 
            sonrisas incluso cuando la vida empezaba a exigirle demasiado pronto. 
            Su bondad no era algo que hiciera, era simplemente lo que era: natural, constante, infinita.
          </p>

          <p>
            El destino, a veces injusto y difícil de comprender, la traicionó demasiado temprano. 
            Carmen emprendió entonces una lucha larga, valiente y silenciosa contra una 
            enfermedad grave. Y lo hizo como vivía: con una fortaleza que no necesitaba 
            palabras y con una dulzura que nunca se apagó.
          </p>

          <p>
            Pero hay personas que no se van del todo, porque dejan algo mucho más grande 
            que su presencia. Carmen es una de ellas. Porque nunca muere lo que no se olvida.
          </p>

          <p>
            Desde entonces, su familia ha decidido transformar el dolor en esperanza, 
            y su recuerdo en acción. En su nombre, en su esencia y en todo lo que ella 
            representaba, trabajan cada día para llevar alegría a otros niños que, 
            como Carmen, atraviesan momentos difíciles. Porque si algo enseñó Carmen 
            es que incluso en los días más oscuros, siempre hay espacio para la luz.
          </p>

          <p>
            Y hoy, esa luz sigue viva. En cada gesto, en cada sonrisa que se arranca 
            al sufrimiento, en cada paso de este reto.
          </p>

          <div className="carmen-highlight">
            <p>Porque Carmen no es solo un recuerdo.</p>
            <p>Carmen es un motor.</p>
            <p>Carmen es inspiración.</p>
            <p>Carmen es, y siempre será, bondad.</p>
          </div>
        </div>
      </article>
    </div>
  );
};

export default ConoceACarmen;